import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Keyboard from "../../components/Keyboard";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';
import axios from "axios";
//import useAuth from "../../../auth/hooks/useAuth";

//import "./fonts/primerprint.ttf";

var { questions } = [];
var currQuestion;


//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastWord = "";
var questionCounter = 0;

//Liam - used to make timer be called and cancelled, wordTime is var for finding question time
var wordTime = 0;
let addWordTimeout;



export default function Game({ ...props }) {
    // const { state: authState } = useAuth();
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const [status, setStatus] = useState("LOADING");
    const [setup, setSetup] = useState(false);
    const [custom, setCustom] = useState(false);
    const [questionMax, setQuestionMax] = useState(-1);

    console.log("tst: hi: " + custom);

    const isWordOnce = props.assessment_type === "wordonce";

    var timer = -1;
    if (props.timelimit > 0) {
        timer = props.timelimit;
    }
    else {
        timer = 120;
    }


    //if question counter is higher than 3 then reset -refeed
    if (questionCounter > 3) {
        questionCounter = 0;
    }


    //console.log(props);
    if (setup == false) {
        //var questionMax = -1;
        if (props.minimum > 0) {
            setQuestionMax(props.minimum);
        }
        questions = undefined;
        console.log(props.topics);
        if (questions == undefined && props.customlist == undefined && setup == false) {

            var params = {
                topics: props.topics,
                game_type: "spelling"
            };
            try {
                (async () => {
                    const response = await axios({
                        method: "get",
                        url: `${process.env.REACT_APP_OAUTH_URL}/lite/topics/questions`,
                        params
                    });
                    setStatus("OK");
                    questions = response.data;
                    if (isWordOnce) {
                        // Set the question limit to the total number of questions in the pool
                        setQuestionMax(questions.length);
                        console.log("question count:" + questionMax);
                        console.log(questions);
                        console.log(questions.length);
                        timer = -1;
                    }
                })();
            } catch (e) {
                setStatus("ERROR");
            }
            setCustom(false);
            setSetup(true);

        } else if (setup == false && props.customlist != undefined) {
            questions = [];
            let list = props.customlist;

            // 1. If it's a string (JSON format), parse it first
            if (typeof list === "string") {
                try {
                    list = JSON.parse(list);
                } catch (e) {
                    console.error("props.customlist is a string but failed to parse as JSON:", e);
                }
            }

            // 2. If it's an object instead of an array, extract its values into an array
            const listArray = Array.isArray(list)
                ? list
                : (list && typeof list === 'object' ? Object.values(list) : []);

            // 3. Safely loop over the guaranteed array
            listArray.forEach(q => {
                // Skip if the item is missing required properties
                if (!q || !q.word || !q.question) return;

                var reg = new RegExp("\\b" + q.word + "\\b", 'i');
                let questionText = q.question.replace(reg, "$"); // do replacement thing
                let qobj = {
                    "question_key": q.id,
                    "sentence": questionText,
                    "word": q.word,
                    "topic_key": q.id,
                    "topic_id": q.id
                };
                questions.push(qobj);
            });

            setStatus("OK");
            setCustom(true);
            setSetup(true);
        }
    }

    const { sayWord } = useSpeech();
    const [currentQuestion, setCurrentQuestion] = useState([]);
    const [wordToSay, setWordToSay] = useState("");
    const [extraChars, setExtraChars] = useState([]);


    function newQuestion() {
        clearTimeout(addWordTimeout);
        var current = currentQuestion ? currentQuestion.word : "";
        var getNewQuestion = true;
        const isWordOnce = props.assessment_type === "wordonce";

        // 1. Completion Check
        if (isWordOnce && questions.length === 0 && !repeating && refeedQuestions.length === 0) {
            setStatus("FINISHED");
            return;
        }

        // 2. Refeed Logic (Keeps incorrect words in a separate loop)
        // FIX: Added !isWordOnce so this block is completely skipped in wordonce mode
        if (!isWordOnce && questionCounter === 2 && refeedQuestions.length > 0) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions.pop();
            setCurrentQuestion(currQuestion);
        }
        // 3. SEQUENTIAL SELECTION (The "Order of Questions" Fix)
        else if (questions.length > 0) {
            repeating = false;

            if (isWordOnce) {
                // ALWAYS take the first item (index 0) to maintain list order
                currQuestion = questions.splice(0, 1)[0];
            } else {
                // For standard modes, you could still use random or an index counter
                // but for wordonce, splice(0, 1) is the cleanest way.
                const randomIndex = Math.floor(Math.random() * questions.length);
                currQuestion = questions[randomIndex];

                if (questions.length > 1 && currQuestion.word === current) {
                    newQuestion();
                    return;
                }
            }

            setCurrentQuestion(currQuestion);

            if (currQuestion.word !== undefined) {
                getLettersFromWord(currQuestion.word);
            }
        }

        // 4. Audio & Timeout logic remains the same...
        if (currQuestion) {
            addWordTimeout = setTimeout(addCurrWord, wordTime);
        }
    }

    //Liam - Get the length of the current word then times it by 2
    //times the total by 1000 to get timer in milliseconds - refeed
    function getLettersFromWord(currWord) {
        wordTime = (currWord.length * 2) * 1000;
    }

    //when time expires, add time to wrong answers list - refeed
    function addCurrWord() {
        // FIX: Guard clause to prevent timeout tracking in wordonce mode
        if (props.assessment_type === "wordonce") return;
        var question = currQuestion;
        refeedQuestions.push(question);
    }

    //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
    function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastWord = "";
        console.log("RESET");
    }


    function getExtraChars(word, level) {
        let alphabet = [
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z"
        ];

        //remove the characters of the current answer from the alphabet
        let remainingChars = alphabet.filter(function (el) {
            return !word.includes(el);
        });

        // worh out the number of extra characters to add
        // Level x character in current word
        const extraChars = [];

        if (level > 1) {
            const wordLength = word.length;
            const extraCharCount = wordLength * (props.level - 1);
            console.log("LEVEL: " + props.level);
            for (var i = 0; i < extraCharCount; i++) {
                if (remainingChars.length > 0) {
                    let char =
                        remainingChars[Math.floor(Math.random() * remainingChars.length)];
                    extraChars.push(char);
                    remainingChars = remainingChars.filter(function (x) {
                        return char.indexOf(x) < 0;
                    });
                }
            }
        }
        if (level == 99) {
            return alphabet;
        }
        return extraChars;
    }

    async function checkResult(value, callback) {

        //set the current question to the last question -refeed
        questionCounter = questionCounter + 1;
        lastWord = currentQuestion.word;

        var addToArray = false;

        let isCorrect = true;
        if (value) {
            if (currentQuestion.word.toLowerCase() === value.toLowerCase()) {
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                isCorrect = true;
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);
                setCombo(combo + 1);

                //check if refeed question is current
                //else is used to make it work, don't want to risk deleting in case it breaks something
                //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
                if (repeating) {
                    refeedQuestions.pop();
                    repeating = false;
                }
                else {
                    repeating = false;
                }

                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setNoFeedback([...nofeedback, result]);
            } else {
                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                isCorrect = false;
                questionCounter = 0;

                // FIX: Wrap the refeed insertion logic so it only fires for standard modes
                if (props.assessment_type !== "wordonce") {
                    //if array is empty push question, if not then check if it already exists
                    //if it does not alredy exists within the array then add to array - refeed
                    //push question to refeed if user gets it wrong - refeed
                    if (refeedQuestions.length === 0) {
                        refeedQuestions.push(currentQuestion);
                        console.log("tst: Refeed Length: " + refeedQuestions.length);
                        console.log("tst: ok: " + refeedQuestions[0]);
                    }
                    else {
                        for (var i = 0; i < refeedQuestions.length; i++) {
                            if (!refeedQuestions.indexOf(currentQuestion.word) > -1) {
                            }
                            else {
                                console.log("tst: Found!");
                                addToArray = true;
                            }
                            if (i === refeedQuestions.length && addToArray) {
                                refeedQuestions.push(currentQuestion);
                                console.log("tst: Refeed Length: " + refeedQuestions.length);
                                console.log("tst: ok: " + refeedQuestions[i]);
                                addToArray = false;
                            }
                        }
                    }
                }



                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }
                let result = {
                    question: currentQuestion.sentence.replace("$", " _ "),
                    correct: currentQuestion.word,
                    incorrect: value
                };
                setFeedback([...feedback, result]);
            }

            if (callback) {
                await callback(isCorrect).then(() => {
                    newQuestion();
                });
            } else {
                newQuestion();
            }
        }
    }



    useEffect(() => {
        if (status !== undefined && status === "OK") {
            console.log("status");
            console.log(questions);
            newQuestion();

            setLoading(false);
        }
    }, [status]);



    //when question changes play the relevant audio
    useEffect(() => {
        if (currentQuestion && currentQuestion.word) {
            // Always try sayWordNew first
            sayWordNew(currentQuestion.word);

            // 1. Check if this session is a homework assignment
            const isHomework = props.homework_id !== undefined && props.homework_id !== null && props.homework_id !== "";

            // 2. Force level 99 (Full Keyboard) if it's custom OR homework.
            // Added a fallback (|| 1) just in case props.level is missing elsewhere.
            const levelToUse = (custom || isHomework) ? 99 : (props.level || 1);
            
            setExtraChars(getExtraChars(currentQuestion.word.split(""), levelToUse));
        }
    }, [currentQuestion]);





    function ComboImage() {
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        console.log("../../assets/" + imageName)
        return (require("../../assets/" + imageName))
    }

    function sayWordNew(word) {
        if (!word || word === "") return;

        console.log("tst: Attempting audio for: " + word);
        const cleanWord = word.toLowerCase().trim();
        const audio = new Audio("/audio/" + cleanWord + ".mp3");

        // 1. Always try to play the audio file first
        audio.play()
            .then(() => {
                console.log("Found audio file: playing " + cleanWord);
            })
            .catch((error) => {
                // 2. FILE NOT FOUND: Fall back straight to TTS
                console.log("Audio file missing. Falling back to TTS.");
                    // For standard tasks, use browser speech synthesis
                    console.log("tst: triggering standard TTS");
                    var msg = new SpeechSynthesisUtterance();
                    msg.text = word;
                    window.speechSynthesis.speak(msg);
            });
    }

    useEffect(() => {
        console.log("SHOULD DO TTS");
        if (wordToSay != null && wordToSay != undefined) {
            sayWord(wordToSay);
        }
    }, [wordToSay]);

    function ChangeWord(word) {
        setWordToSay(" ");
        console.log("I am changing the word");
        setWordToSay(word + " ");
    }

    console.log(props);

    return (
        <>
            <PracticeGame
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                score={score}
                defaultTimer={timer}
                questionLimit={questionMax}
                onBack={() => {
                    props.onBack();
                    clearTimeout(addWordTimeout);
                    Reset();
                }}
                loading={loading}
                feedback={feedback}
                nofeedback={nofeedback}
                questionFontSize="0.7em"
                custom={custom}
                restart={() => {
                    setCombo(0);
                    setScore(0);
                    setCorrectQuestions([]);
                    setIncorrectQuestions([]);
                    clearTimeout(addWordTimeout);
                    Reset();
                }}
                homework_id={props.homework_id}
            >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={1720}>
                        <Body>
                            {currentQuestion !== undefined &&
                                <div>
                                    <Keyboard
                                        currentQuestion={currentQuestion}
                                        onSubmitted={checkResult}
                                        playAudioButton={true}
                                        onPlayAudio={() => sayWordNew(currentQuestion.word)}
                                        additionalCharacters={extraChars}
                                    />
                                </div>
                            }

                            <Combo>
                                <span style={{ fontSize: "50px" }}>{combo}</span>
                                <span style={{ fontSize: "20px" }}>COMBO</span>
                            </Combo>
                        </Body>
                    </Scale>
                </div>
            </PracticeGame>
        </>
    );
}

const Body = styled.div`
    font-family: "PrimerPrint";
    width: 100%;
    height: 100%;
    background-image: url("${props => props.gameBackground}");
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 100px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
    margin-left: 50px;
`;

